import { useRequest } from 'ahooks';
import { atom, useAtomValue, useSetAtom } from 'jotai';

import { getJackpotInfo } from '@/api/jackpot';

import { emitterAtom } from './emitter';

/* jackpotAtom: 奖池及用户信息 */
export const jackpotAtom = atom({
  pool: '000000.00',
  score: 0,
  score_exp: 0,
  gold: 0,
  cashstart: 0
});
export const jackpotHeartbeatAtom = atom('000000.00');
/* jackpotSpinAtom: 奖池是否达到spin条件 */
export const jackpotSpinAtom = atom(get => {
  const userInfo = get(jackpotAtom);
  const score = userInfo?.score || 0;
  const scoreExp = userInfo?.score_exp || 0;
  return score && scoreExp && scoreExp > 0 && score >= scoreExp;
});
/* jackpotRetarirAtom: 奖池是否达到提现条件 */
export const jackpotRetarirAtom = atom(get => {
  const userInfo = get(jackpotAtom);
  const gold = userInfo?.gold || 0;
  const cashstart = userInfo?.cashstart || 0;
  return gold && cashstart && cashstart > 0 && gold >= cashstart;
});

export const useJackpotStore = () => {
  const emitter = useAtomValue(emitterAtom);
  const setJackpot = useSetAtom(jackpotAtom);
  const setJackpotHeartbeat = useSetAtom(jackpotHeartbeatAtom);
  const { run: getJackpot } = useRequest(getJackpotInfo, {
    manual: true,
    onSuccess: data => {
      const record: any = data?.record || {};
      const info = {
        pool: parseFloat(data?.pool?.toFixed(2) || '000000.00'),
        ...record,
        ...(record?.info || {})
      };
      setJackpot(info);
      setJackpotHeartbeat(data?.pool?.toFixed(2) || '000000.00');
    }
  });
  emitter.useSubscription(({ type, data }) => {
    if (type === 'jpscore_update' && data?.jp) {
      setTimeout(() => {
        setJackpotHeartbeat(data?.jp?.toFixed(2) || '000000.00');
      }, 0);
    }
    if (type === 'jpinfo_update') {
      getJackpot();
    }
  });
  return [getJackpot];
};
